import classNames from 'classnames';
import { Heading } from 'yoso';
import { BaseCard } from '~/components/Card';
import { PlaceholderGrid } from '~/components/Grid/Placeholder/PlaceholderGrid';
import { Translation } from '~/components/I18n';
import { MissionDescriptionList } from '~/components/Mission/Card/List/MissionDescriptionList';
import { Mission } from '~/components/Mission/Mission.hooks';
import { MissionStamp } from '~/components/Mission/Stamp/MissionStamp';
import { NftContent } from '~/components/Nft/Content/NftContent';
import styles from './MissionCard.module.scss';
import contentStyles from './MissionContent.module.scss';

export type MissionCardProps = {
  className?: string;
} & Mission;
export const MissionCard = ({ className, ...mission }: MissionCardProps) => {
  const { status, title, rewardAmount, missionItemList, missionCompleted } = mission;
  const ended = status === 'ended';
  const completedItems = missionItemList.filter((item) => item.owned);

  return (
    <BaseCard
      className={classNames(
        styles.root,
        {
          [styles.completed]: missionCompleted,
        },
        styles[status],
        className
      )}
      size="large"
      shadow>
      <div className={styles.header}>
        <Heading className={styles.heading}>
          {title}
          <small>
            <Translation name="citizen_mission_section_title" options={[rewardAmount]} />
          </small>
        </Heading>
        <span className={styles.count}>
          <em>{completedItems.length}</em> / {missionItemList.length}
        </span>
      </div>
      <div className={styles.body}>
        <MissionDescriptionList className={styles.descriptionList} {...mission} />
        <PlaceholderGrid
          className={styles.list}
          placeholder={
            <NftContent
              className={contentStyles.placeholder}
              contentsUrl=""
              contentsType="IMAGE"
              originContentsUrl=""
            />
          }>
          {missionItemList.map(({ owned, contentsUrl, thumbnailUrl, name, marketplaceUrl }, i) => (
            <li key={i}>
              <div
                className={classNames(contentStyles.root, {
                  [contentStyles.checked]: owned,
                })}>
                <a href={ended || owned ? undefined : marketplaceUrl}>
                  <NftContent
                    className={contentStyles.content}
                    originContentsUrl={owned ? contentsUrl : thumbnailUrl}
                    contentsUrl={owned ? contentsUrl : thumbnailUrl}
                    contentsType="IMAGE"
                  />
                </a>
                <Heading level={6} className={contentStyles.heading}>
                  {name}
                </Heading>
              </div>
            </li>
          ))}
        </PlaceholderGrid>
      </div>
      {(missionCompleted || ended) && <MissionStamp className={styles.stamp} ended={ended} />}
    </BaseCard>
  );
};
